import React, { useState } from "react";
import { Formik } from "formik";
import _ from "lodash";
import { useQuery } from "@apollo/client";

import gqlProviders from "../../../gql/providers";

function Filter({ refetch, setPageNo, setLimit, refetchExcelDataResponse }) {
  const [providers, setProviders] = useState([]);

  const addData = (values) => {
    let data = _.cloneDeep(values);
    setPageNo(1);
    let obj = {
      full_name: values.name,
      beneficiary_file_id: values.fileID,
      providers_id: values.providerId,
      document_id: values.documentID,
      contact_number: values.contact,
      limit: 10,
      page: 1,
    };

    console.log("obj :: ", obj);

    refetch({
      filters: Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });

    delete obj.limit;
    delete obj.page;

    refetchExcelDataResponse({
      input: Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });
  };

  const formatProvidersData = (data) => {
    let returnData = [];
    if (data?.length > 0) {
      data.map((item) => {
        returnData.push({
          id: item.ID,
          name: item.NameEn,
        });
      });
    } else {
    }
    return returnData;
  };

  const {
    loading: loadingProviders,
    error: errorProvider,
    data: providersData,
    refetch: refetchProviders,
  } = useQuery(gqlProviders.GET_ALL_PROVIDERS_WITHOUT_PAGINATION);

  React.useEffect(() => {
    if (providersData) {
      setProviders(formatProvidersData(providersData?.getAllProviders?.Data));
    }
  }, [providersData]);

  return (
    <Formik
      initialValues={{
        name: "",
        documentID: "",
        contact: "",
        fileID: "",
        memberCardID: "",
        providerId: "",
      }}
      validate={(values) => {
        const errors = {};
      }}
      onSubmit={(values, { setSubmitting }) => {
        addData(values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        /* and other goodies */
      }) => (
        <form className="space-y-6" action="#" method="POST">
          <div className="bg-white px-4 shadow sm:rounded-lg pb-6 mb-3">
            <div className="md:grid md:grid-cols-3 md:gap-6">
              <div className="mt-3 md:col-span-3 md:mt-0">
                <div className="grid grid-cols-6 gap-6 mt-4">
                  <div className="sm:col-span-2 col-span-6">
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Name
                    </label>
                    <input
                      placeholder="Enter Name"
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="name"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                  <div className="sm:col-span-2 col-span-6">
                    <label
                      htmlFor="documentID"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Document ID
                    </label>
                    <input
                      placeholder="Enter Document ID"
                      type="text"
                      name="documentID"
                      value={values.documentID}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="documentID"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                  <div className="sm:col-span-2 col-span-6">
                    <label
                      htmlFor="contact"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Contact
                    </label>
                    <input
                      placeholder="Enter Contact"
                      type="text"
                      name="contact"
                      value={values.contact}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="contact"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                  <div className="sm:col-span-2 col-span-6">
                    <label
                      htmlFor="fileID"
                      className="block text-sm font-medium text-gray-700"
                    >
                      File ID
                    </label>
                    <input
                      placeholder="Enter File ID"
                      type="text"
                      name="fileID"
                      value={values.fileID}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="fileID"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                  {/* <div className="sm:col-span-2 col-span-6">
                    <label
                      htmlFor="memberCardID"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Member Card ID
                    </label>
                    <input
                      placeholder="Enter Member Card ID"
                      type="text"
                      name="memberCardID"
                      value={values.memberCardID}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="memberCardID"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div> */}
                  {/* <div className="sm:col-span-2 col-span-6">
                    <label
                      htmlFor="providerId"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Provider
                    </label>
                    <select
                      id="Type"
                      name="providerId"
                      onChange={handleChange}
                      value={values.providerId}
                      autoComplete="type-name"
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    >
                      <option value="">Please Select</option>
                      {providers.map((item) => {
                        return <option value={item.id}>{item.name}</option>;
                      })}
                    </select>
                  </div> */}
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={handleSubmit}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default Filter;
